module.exports = __webpack_public_path__ + "img/m3.5071bc10.jpg";